import { ACCOUNT, RESPONSEDATA } from "app/shared/services/services-model.type";
import { DataTransferCreate } from "../../reducer/types";
import {
  FETCH_TRANSFER_FOREIGN_CREATE_REQUEST,
  FETCH_TRANSFER_FOREIGN_CREATE_SUCCESS,
  FETCH_TRANSFER_FOREIGN_CREATE_FAILURE,
  FETCH_TRANSFER_FOREIGN_CONFIRM_REQUEST,
  FETCH_TRANSFER_FOREIGN_CONFIRM_SUCCESS,
  FETCH_TRANSFER_FOREIGN_CONFIRM_FAILURE,
  FETCH_TRANSFER_FOREIGN_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_FOREIGN_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TRANSFER_FOREIGN_AUTHORIZATION_KEY_FAILURE,
  FETCH_TRANSFER_FOREIGN_ACCOUNT_DETAIL_REQUEST,
  FETCH_TRANSFER_FOREIGN_ACCOUNT_DETAIL_SUCCESS,
  FETCH_TRANSFER_FOREIGN_ACCOUNT_DETAIL_FAILURE,
  FETCH_TRANSFER_FOREIGN_MAKE_FEE_REQUEST,
  FETCH_TRANSFER_FOREIGN_MAKE_FEE_SUCCESS,
  FETCH_TRANSFER_FOREIGN_MAKE_FEE_FAILURE,
  SET_TRANSFER_FOREIGN_STORE,
  SET_TRANSFER_FOREIGN_RESET,
} from "./actions.type";
import {
  FetchTransferForeignCreateRequest,
  FetchTransferForeignCreateSuccess,
  FetchTransferForeignCreateFailure,
  FetchTransferForeignConfirmRequest,
  FetchTransferForeignConfirmSuccess,
  FetchTransferForeignConfirmFailure,
  FetchTransferForeignAuthorizationRequest,
  FetchTransferForeignAuthorizationSuccess,
  FetchTransferForeignAuthorizationFailure,
  SetTransferForeignStore,
  TransferForeignState,
  SetTransferForeignReset,
  FetchTransferForeignAccountDetailRequest,
  FetchTransferForeignAccountDetailSuccess,
  FetchTransferForeignAccountDetailFailure,
  FetchTransferForeignMakeFeeFailure,
  FetchTransferForeignMakeFeeSuccess,
  FetchTransferForeignMakeFeeRequest,
} from "./types";

// Foreign
export const fetchTransferForeignCreateRequest = (payload: DataTransferCreate): FetchTransferForeignCreateRequest => ({
  type: FETCH_TRANSFER_FOREIGN_CREATE_REQUEST,
  payload,
});

export const fetchTransferForeignCreateSuccess = (payload?: RESPONSEDATA): FetchTransferForeignCreateSuccess => ({
  type: FETCH_TRANSFER_FOREIGN_CREATE_SUCCESS,
  payload,
});

export const fetchTransferForeignCreateFailure = (payload?: string): FetchTransferForeignCreateFailure => ({
  type: FETCH_TRANSFER_FOREIGN_CREATE_FAILURE,
  payload,
});

export const fetchTransferForeignConfirmRequest = (payload?: RESPONSEDATA): FetchTransferForeignConfirmRequest => ({
  type: FETCH_TRANSFER_FOREIGN_CONFIRM_REQUEST,
  payload,
});

export const fetchTransferForeignConfirmSuccess = (payload?: RESPONSEDATA): FetchTransferForeignConfirmSuccess => ({
  type: FETCH_TRANSFER_FOREIGN_CONFIRM_SUCCESS,
  payload,
});

export const fetchTransferForeignConfirmFailure = (payload?: string): FetchTransferForeignConfirmFailure => ({
  type: FETCH_TRANSFER_FOREIGN_CONFIRM_FAILURE,
  payload,
});

export const fetchTransferForeignAuthorizationRequest = (
  payload?: RESPONSEDATA,
  code?: string,
): FetchTransferForeignAuthorizationRequest => ({
  type: FETCH_TRANSFER_FOREIGN_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTransferForeignAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTransferForeignAuthorizationSuccess => ({
  type: FETCH_TRANSFER_FOREIGN_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTransferForeignAuthorizationFailure = (
  errorOTP: boolean,
  payload?: string,
): FetchTransferForeignAuthorizationFailure => ({
  type: FETCH_TRANSFER_FOREIGN_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

export const setTransferForeignStore = (payload: TransferForeignState): SetTransferForeignStore => ({
  type: SET_TRANSFER_FOREIGN_STORE,
  payload,
});

export const setTransferForeignReset = (): SetTransferForeignReset => ({
  type: SET_TRANSFER_FOREIGN_RESET,
});

// Transfer Detail Account
export const fetchTransferForeignAccountDetailRequest = (payload: DataTransferCreate): FetchTransferForeignAccountDetailRequest => ({
  type: FETCH_TRANSFER_FOREIGN_ACCOUNT_DETAIL_REQUEST,
  payload,
});

export const fetchTransferForeignAccountDetailSuccess = (payload?: ACCOUNT): FetchTransferForeignAccountDetailSuccess => ({
  type: FETCH_TRANSFER_FOREIGN_ACCOUNT_DETAIL_SUCCESS,
  payload,
});

export const fetchTransferForeignAccountDetailFailure = (payload?: string): FetchTransferForeignAccountDetailFailure => ({
  type: FETCH_TRANSFER_FOREIGN_ACCOUNT_DETAIL_FAILURE,
  payload,
});

// Tính phí
export const fetchTransferForeignMakeFeeRequest = (payload: DataTransferCreate): FetchTransferForeignMakeFeeRequest => ({
  type: FETCH_TRANSFER_FOREIGN_MAKE_FEE_REQUEST,
  payload,
});

export const fetchTransferForeignMakeFeeFailure = (payload?: string): FetchTransferForeignMakeFeeFailure => ({
  type: FETCH_TRANSFER_FOREIGN_MAKE_FEE_FAILURE,
  payload,
});

export const fetchTransferForeignMakeFeeSuccess = (payload?: RESPONSEDATA): FetchTransferForeignMakeFeeSuccess => ({
  type: FETCH_TRANSFER_FOREIGN_MAKE_FEE_SUCCESS,
  payload,
});
